<template>
  <div class="asc-role-dialog-grid-wrapper--container">
    <asc-role-dialog-grid
      :values="values"
      :on-open="onOpen"
      :grid-columns="gridColumns"
      :grid-filters="gridFilters"
      :all-resource-modules="allResourceModules"
      v-on="$listeners"
    ></asc-role-dialog-grid>
  </div>
</template>

<script>
import { AscGridPropsMixin } from '@/components/mixins'
import AscRoleDialogGrid from '@/components/molecules/AscRoleDialogGrid'

export default {
  name: 'AscRoleDialogGridWrapper',

  components: {
    AscRoleDialogGrid,
  },

  mixins: [AscGridPropsMixin],

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Admin - Role Management Editor',
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
    allResourceModules: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {}
  },
}
</script>

<style lang="scss">
.asc-role-dialog-grid-wrapper--container {
  .asc-role-dialog-grid {
    .ag-group-value {
      font-weight: bold;
    }
    .ag-cell-value {
      padding-left: 40px;
    }
    .asc-checkbox {
      text-align: center;
    }
  }
}
</style>
